import { Task } from '../models/task.model';

export class TaskMapper {
  public mapPutTaskRequest(data: Task) {
    const request = {
      UId: data.uId,
      InfoDesc: data.infoDesc,
      LongDesc: data.longDesc,
      Number: data.number,
      Author: data.author,
      ProjectId: data.project?.uId ?? undefined,
      Type: 1,
      CustomerId: data.customer?.uId ?? undefined,
      LocationId: data.location?.uId ?? undefined,
      PaymentTermId: data.paymentTerm?.uId ?? undefined,
      ZeroSet: data.zeroSet,
      ReducedSet: data.reducedSet,
      FullSet: data.fullSet,
    };

    return request;
  }

  public taskMap(x: Task): Task {
    x.stampCreate = new Date(String(x.stampCreate)).toISOString();
    x.stampEdit = x.stampEdit
      ? new Date(String(x.stampEdit)).toISOString()
      : undefined;

    if (x.appointment) {
      x.appointment.startDate = new Date(String(x.appointment.startDate));
      x.appointment.endDate = new Date(String(x.appointment.endDate));
    }

    if (x.statusHistory && x.statusHistory.length > 0) {
      x.statusHistory.map((s) => {
        s.stampCreate = new Date(String(s.stampCreate)).toISOString();
        s.stampEdit = s.stampEdit
          ? new Date(String(s.stampEdit)).toISOString()
          : undefined;
        return s;
      });
    }

    if (x.items && x.items.length > 0) {
      x.items.map((i) => {
        i.stampCreate = new Date(String(i.stampCreate)).toISOString();
        i.stampEdit = i.stampEdit
          ? new Date(String(i.stampEdit)).toISOString()
          : undefined;
        return i;
      });
    }

    return x;
  }

  public mapOfferRequest(data: Task) {
    const request = {
      UId: data.uId,
      InfoDesc: data.infoDesc,
      LongDesc: data.longDesc,
      Number: data.number,
      ProjectId: data.project?.uId ?? undefined,
      CustomerId: data.customer?.uId ?? undefined,
      LocationId: data.location?.uId ?? undefined,
    };

    return request;
  }
}
